module.exports = __webpack_public_path__ + "static/media/LandlordIconHomeCTA.a758375d.svg";